import { MimaButton, MimaDropdown, MimaInput, MimaText, Modal } from '../../components';
import { Formik } from 'formik';

const AddFaq = ({
    loading,
    validationSchema,
    onSubmit,
    closeModal,
    data,
}) => {
   
    return (
        <Modal closeModal={closeModal}>
            <Formik
                initialValues={{
                    question: "",
                    answer: "",
                    faqCategory: "",
                }}
                onSubmit={onSubmit}
                validationSchema={validationSchema}
            >
                {({
                    handleBlur,
                    handleChange,
                    handleSubmit,
                    setFieldValue,
                    values,
                    errors,
                    touched,
                }) => (
                    <>
                        <MimaText variant="subtitleBold" mb={4}>Create New FAQ</MimaText>
                        <MimaInput
                            labelTitle="Question"
                            name="question"
                            value={values.question}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={errors.question}
                            touched={touched.question}
                        />
                        <MimaInput
                            labelTitle="Answer"
                            name="answer"
                            value={values.answer}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={errors.answer}
                            touched={touched.answer}
                        />                       
                        <MimaDropdown
                            labelTitle="faqCategory"
                            placeholder="Select"
                            name="faqCategory"
                            value={values.faqCategory}
                            id="faqCategory"
                            onChange={data => {
                                setFieldValue('faqCategory', data.key);                                
                            }}
                            data={data}
                            error={errors.faqCategory}
                            touched={touched.faqCategory}
                        />
                        <MimaButton
                            title="Add"
                            width={38}
                            mt={2}
                            buttonColor="var(--color-dark-4)"
                            onClick={handleSubmit}
                            loading={loading}
                        />
                    </>
                )}

            </Formik>
        </Modal>
    )
}
export default AddFaq;